<div class="row" *ngIf="refStatus && refStatus.isActive == 1">
	<div class="col-md-12">
		<strong>
			<h3>{{ 'adminstat.common.rebuildingReferers' | translate }}</h3>
			<br>{{ 'adminstat.users.group_ref_new.start at' | translate }} {{ refStatus.dateStart }}
		</strong>

		<br><br>

		<div class="progress">
			<div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" attr.aria-valuenow="{{ refStatus.procent }}" aria-valuemin="0" aria-valuemax="100" [ngStyle]="{'width': refStatus.procent + '%'}">
				{{ refStatus.procent }}%
			</div>
		</div>

		<br><br>
	</div>
</div>
